import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ページ遷移のたびにウィンドウを最上部にスクロールするコンポーネント。
 * BrowserRouter 内に配置して使用する。
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}
